import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Card, CardContent, Grid, CircularProgress } from '@mui/material';
import { Connection, PublicKey } from '@solana/web3.js';
import { FaMedal, FaUsers } from 'react-icons/fa';

const connection = new Connection('https://solana-api.instantnodes.io/token-dDjzjvTC4AqlHXog4ag6ptCkSpA87qAl');

function Dashboard({ programId }) {
  const [engagementData, setEngagementData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEngagementData = async () => {
      try {
        const programPublicKey = new PublicKey(programId);
        const accountInfo = await connection.getAccountInfo(programPublicKey);
        
        if (accountInfo) {
          const data = new DataView(accountInfo.data.buffer);
          const points = data.getUint32(0, true); // Read as little-endian unsigned 32-bit integer
          const engagements = data.getUint32(4, true); // Read as little-endian unsigned 32-bit integer
          setEngagementData({ points, engagements });
        }
      } catch (error) {
        console.error('Error fetching engagement data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEngagementData();
  }, [programId]);

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Engagement Monitoring Dashboard
        </Typography>
        <Typography variant="h6" component="h6" gutterBottom color="textSecondary">
          Monitoring Program: {programId}
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ backgroundColor: '#f3f4f6', textAlign: 'center' }}>
            <CardContent>
              <FaMedal size={40} color="#ffcc00" />
              <Typography variant="h6" gutterBottom>
                Engagement Points
              </Typography>
              {loading ? (
                <CircularProgress />
              ) : (
                <Typography variant="h5" color="textSecondary">
                  {engagementData?.points ?? 'N/A'}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ backgroundColor: '#f3f4f6', textAlign: 'center' }}>
            <CardContent>
              <FaUsers size={40} color="#00b0ff" />
              <Typography variant="h6" gutterBottom>
                Total Engagements
              </Typography>
              {loading ? (
                <CircularProgress />
              ) : (
                <Typography variant="h5" color="textSecondary">
                  {engagementData?.engagements ?? 'N/A'}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Dashboard;